// Truy vấn OKR / KPI / thông báo dùng chung giữa hook (okr-kpi.ts) và lượt tải trước lúc khởi động (napTruoc trong
// du-lieu.ts): cùng khoá + cùng hàm → hook nhận luôn dữ liệu, hoặc lượt gọi đang bay, của lượt tải trước. Tách khỏi
// okr-kpi.ts để lượt tải trước không kéo cả công thức (server/chi-so.ts) vào bundle đầu.
import { queryOptions } from '@tanstack/react-query';
import type { KetQua } from '../../server/chi-so';
import { api } from './api';
import type { Kpi, KpiSo, ThongBaoMuc } from './okr-kpi';

export const KHOA2 = { kr: ['ket-qua'], kpi: ['kpi'], thongBao: ['thong-bao'], checkin: (id: number) => ['checkin', id] };

export const qKetQua = queryOptions({
  queryKey: KHOA2.kr,
  queryFn: async () => (await api.get<{ ds: KetQua[] }>('ket-qua')).ds,
  staleTime: 60_000,
});

export const qKpi = queryOptions({
  queryKey: KHOA2.kpi,
  queryFn: () => api.get<{ ds: Kpi[]; so: KpiSo[] }>('kpi'),
  staleTime: 60_000,
});

export const qThongBao = queryOptions({
  queryKey: KHOA2.thongBao,
  queryFn: () => api.get<{ ds: ThongBaoMuc[]; chua_doc: number }>('thong-bao'),
  refetchInterval: 60_000,
  staleTime: 30_000,
});
